var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2181 6.10189C17.4583 6.31455 17.6854 6.5416 17.898 6.78178L20.4595 7.14755C20.8749 7.87087 21.1951 8.6448 21.4123 9.45013L19.8604 11.5194C19.8604 11.5194 19.8799 12.1606 19.8604 12.4807L21.413 14.5506C21.1953 15.3558 20.8745 16.1295 20.4586 16.8525L17.898 17.2183C17.898 17.2183 17.4584 17.6855 17.2183 17.8981L16.8525 20.4596C16.1292 20.875 15.3552 21.1953 14.5499 21.4125L12.4808 19.8605C12.1606 19.88 11.8395 19.88 11.5193 19.8605L9.44943 21.4131C8.64424 21.1954 7.87053 20.8746 7.14749 20.4587L6.78179 17.8983C6.54161 17.6856 6.31456 17.4586 6.1019 17.2184L3.54043 16.8526C3.12505 16.1293 2.80478 15.3554 2.58759 14.55L4.13957 12.4808C4.13957 12.4808 4.12005 11.8396 4.13951 11.5194L2.58691 9.44956C2.80466 8.64437 3.12545 7.87066 3.54132 7.14762L6.10178 6.78192C6.31443 6.54174 6.54148 6.31469 6.78166 6.10203L7.14743 3.54056C7.87075 3.12517 8.64468 2.80491 9.45001 2.58771L11.5191 4.13964C11.8393 4.12017 12.1604 4.12017 12.4806 4.13963L14.5505 2.58704C15.3557 2.80478 16.1294 3.12557 16.8524 3.54144L17.2181 6.10189Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.1bd15166.svg";
export { ForwardRef as ReactComponent };